import { getSnappedMousePosition } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/actions/utils/getSnappedMousePosition';
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import {
  Belegung,
  BelegungsIntervall,
} from '@/domain/dienstplan/shared/types/Belegung';
import { Point } from 'recharts/types/shape/Curve';

export function startBelegungHeightResize({
  ctx,
  currentPoint,
  currentBelegung,
}: {
  currentPoint: Point;
  currentBelegung: BelegungsIntervall;
  ctx: SharedContext;
}) {
  const {
    store: { updateBelegungById, setStartBelegungPosition, setIsResizingStart },
  } = ctx;

  const { x, y } = getSnappedMousePosition(ctx, currentPoint);

  const newBelegung = new Belegung({
    ...currentBelegung.belegung,
    personenanzahlMax: y,
  });

  updateBelegungById(
    new BelegungsIntervall(newBelegung, 'resize-height'),
    newBelegung.id,
  );
  setStartBelegungPosition({ x, y });
  setIsResizingStart(true);
}
